const INVENTORY_STATUS = {
  INCREMENT: 1,
  DECREMENT: 2,
} as const;

// eslint-disable-next-line import/prefer-default-export
export { INVENTORY_STATUS };
